<!-- The datePicker component -->
<template>
    <v-dialog 
        ref="dialog"
        :return-value.sync="date"
        v-model="GET_datePicker.show"
        width="300"
        >
        <v-date-picker color="primary" v-model="date">
            <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="closeDatePicker()"
          >
            Cancel
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.dialog.save(date)"
          >
            OK
          </v-btn>
        </v-date-picker>
    </v-dialog>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    export default {
        data: () => ({
            date: new Date().toISOString().substr(0, 10),
        }),
        computed: {
            ...mapGetters({
                GET_datePicker: 'datePicker_store/GET_datePicker',
                GET_datePickerResult: 'datePicker_store/GET_datePickerResult'
            }),
        },
        methods: {
            ...mapActions({
                ACT_datePickerResult: 'datePicker_store/ACT_datePickerResult',
            }),
            closeDatePicker() {
                this.MIX_datePicker(false, '');
            }
        },
        watch: {
            date: {
                handler() {
                    this.ACT_datePickerResult({ field: this.GET_datePicker.field, value: this.$moment(this.date, 'YYYY-MM-DD').format('x')})
                }, deep: true
            }
        }
    }
</script>